import React from 'react';
import { List } from 'immutable';
import {
  CoreLink,
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphTextWithIconContainer = ({ entity }) => {
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const gridType = entity.get('field_paragraphs', List()).size % 2 === 0 ? 'even' : 'uneven';
  return (
    <Container className="ParagraphTextWithIconContainer">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          {title && (
            <div className="ParagraphTextWithIconContainer__title">
              <h2>{title}</h2>
            </div>
          )}

          {text && (
            <div className="ParagraphTextWithIconContainer__text">

              <WysiwygField
                property="schema:text"
                html={text}
              />
            </div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {/* Start of items */}
          {entity.get('field_paragraphs').size > 0 ? (
            <div className="node--page--paragraphs-wrapper">
              <div className={`ParagraphTextWithIconContainer__grid ${gridType}`}>
                {entity.get('field_paragraphs', List()).map((paragraph) => {
                  const id = paragraph.get('target_id');
                  return (
                    <Paragraph
                      key={`paragraph:${id}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            </div>
          ) : null}
          {/* End of paragraphs */}

          {linkUrl && (
            <div className="ParagraphTextWithIconContainer__link">
              <CoreLink className="Button Button--primary" to={linkUrl}>
                {linkTitle}
                <i className="icon icon-arrow-right" />
              </CoreLink>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphTextWithIconContainer;
